import { createApp } from 'vue'
import { createPinia } from 'pinia';
import App from './App.vue'
import router from './router';
import UUID from "vue3-uuid";

import { IonicVue } from '@ionic/vue';

import '@ionic/vue/css/ionic.bundle.css';

/* Theme variables */
import './theme/variables.css';
import './theme/global.css';

const pinia = createPinia()
const app = createApp(App)
  .use(IonicVue)
  .use(pinia)
  .use(router)
  .use(UUID);
  
router.isReady().then(() => {
  app.mount('#app');
});